export default [
  {
    question: `What do I need to know?`,
    answer: `Staking via Unagii delegates to the Stakewithus validator to help secure the network and receive a share of incentivized rewards earned. Rewards are earned by staking tokens and are paid out on a per block basis. Users can withdraw or compound at any time.`,
  },
  {
    question: `What is the inflation?`,
    answer: `During the bootstrap phase (days 1 - 935), 246,575 BLD tokens are emitted daily. Thereafter, BLD issuance declines linearly from 246,575 to 0 during days 934 - 1093, and no further BLD will be issued thereafter. BLD rewards are phased out as RUN rewards grow in value as the network matures. BLD stakers may choose to modify issuance schedule as needed in the future.`,
  },
  {
    question: `Is there a lock-up period?`,
    answer: `There is a 21 days unbonding period when unstaking BLD from the network. Users will not earn rewards and will be susceptible to slashing during unbonding.`,
  },
  {
    question: `How to restake?`,
    answer: `Users may manually withdraw rewards and restake to compound their returns. Enabling auto-compound via REstake by Eco Stake is also an available option.`,
  },
  {
    question: `Is there a fee?`,
    answer: `There is a delegation commission fee paid to Stakewithus for staking.`,
  },
  {
    question: `What are the risks?`,
    answer: `Staking risks do apply including slashing involved for downtime and double signing.`,
  },
];
